import React from 'react';
import * as PropTypes from 'prop-types';
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Button, Typography, notification,
} from 'antd';
import { injectIntl, useIntl } from 'react-intl';
import routeLocations from '../../../utility/route-locations';
import { selectVerifyUserEmailRequest } from '../../../state/ui/configuration/users/emailUiReducer';
import { requestVerifyEmail, requestSendVerificationEmail } from '../../../state/ui/configuration/users/emailUiActions';
import { selectSessionUser } from '../../../state/ui/application/sessionUiReducer';

const { Text } = Typography;

function VerifyEmail({
  location,
  sendNewVerificationEmail,
  verifyEmailOnServer,
  sessionUser,
}) {
  const tokenstart = location.pathname.lastIndexOf('/verify-email');
  const intl = useIntl();

  if (tokenstart !== -1 && !sessionUser.emailVerified) {
    const failNotificationDescription = (
      <div>
        <Text>{intl.formatMessage({ id: 'verifyEmailFailure' })}</Text>
        <Button
          type="primary"
          block
          onClick={() => { notification.close('resend-verification-email'); sendNewVerificationEmail(); }}
        >
          {intl.formatMessage({ id: 'verifyEmailResend' })}
        </Button>
      </div>
    );
    const requestToken = location.pathname.slice(tokenstart, location.pathname.length);
    const failNotification = () => notification.warn({
      key: 'resend-verification-email',
      message: intl.formatMessage({ id: 'emailVerifyFail' }),
      description: failNotificationDescription,
      duration: null,
    });
    verifyEmailOnServer(
      requestToken,
      failNotification,
    );
  }

  return <Redirect to={routeLocations.dashboard} />;
}

VerifyEmail.propTypes = {
  location:
    PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,
  sessionUser: PropTypes.shape({
    username: PropTypes.string.isRequired,
    emailVerified: PropTypes.bool.isRequired,
  }),
  verifyError: PropTypes.shape({
    code: PropTypes.number.isRequired,
    errorMessage: PropTypes.string.isRequired,
    errors: PropTypes.array,
  }),
  verifyEmailOnServer: PropTypes.func.isRequired,
  sendNewVerificationEmail: PropTypes.func.isRequired,
};

VerifyEmail.defaultProps = {
  sessionUser: null,
  verifyError: null,
};

const mapStateToProps = (state) => {
  const verifyRequest = selectVerifyUserEmailRequest(state);
  return {
    sessionUser: selectSessionUser(state),
    verifyError: verifyRequest ? verifyRequest.error : null,
  };
};

const mapDispatchToProps = dispatch => ({
  verifyEmailOnServer: (requestToken, resendEmailLink) => dispatch(requestVerifyEmail(requestToken, resendEmailLink)),
  sendNewVerificationEmail: () => dispatch(requestSendVerificationEmail()),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  injectIntl(
    withRouter(VerifyEmail),
  ),
);
